// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"IndexHero_heroContainer__CDCiP","coverVideo":"IndexHero_coverVideo__n_w5n","overlay":"IndexHero_overlay__O1C3C"};